export const columns = function () {
  // 日期，机构名称，车牌号，车型，被统筹人，客户统筹费，客户折扣，原始标统，原始折扣，折扣统筹费（根据原始统筹单和原始折扣计算），净费，实收金额，收款方式，是否开票，税点，返费
  return [
    {
      prop: "create_time",
      label: "日期",
      minWidth: 100,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "carType",
      label: "车型",
      minWidth: 100,
    },
    {
      prop: "carOwner",
      label: "被统筹人",
      minWidth: 100,
    },
	{
	  prop: "customerRebate",
	  label: "客户折扣",
	  minWidth: 100,
	},
    {
      prop: "customerFee",
      label: "客户统筹费",
      minWidth: 100,
    },
    {
      prop: "originalFee",
      label: "原始标统",
      minWidth: 100,
    },
    {
      prop: "originalRebate",
      label: "原始折扣",
      minWidth: 100,
    },
    {
      prop: "discountFee",
      label: "原始折扣统筹费",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费",
      minWidth: 100,
    },
    {
      prop: "receiptFee",
      label: "实收金额",
      minWidth: 100,
    },
    {
      prop: "receiptType",
      label: "收款方式",
      minWidth: 100,
    },
    {
      prop: "isInvoice",
      label: "是否开票",
      minWidth: 100,
    },
    {
      prop: "taxPoint",
      label: "税费",
      minWidth: 100,
    },
    {
      prop: "returnFee",
      label: "返费",
      minWidth: 100,
    },
	{
	  prop: "beginTime",
	  label: "统筹起期",
	  minWidth: 100,
	},
	{
	  prop: "endTime",
	  label: "统筹止期",
	  minWidth: 100,
	},
  ];
};

export default {};
